import { useEffect, useRef, useState } from "react";
import SalaryField from "../../../../components/SalaryField";
import closeIcon from "../../../../assets/close-icon.svg";
import addBtn from "../../../../assets/add-button.svg";

import { API_BASE_URL } from "../../../../config";
import Loader from "../../../../components/Loader";
import SearchSkillsAll from "../../../../components/SearchSkillsAll";
import JobPreferences from "../../../../components/JobPreferences";

export default function EditProfileWork({
  details,
  handleInput,
  handlePreferences,
  handleIdealCompanies,
  handleSkillsChange,
  handleOtherCompanies,
}) {
  const [selectValue, setSelectValue] = useState("");
  const [selectedIdealCompany, setSelectedIdealCompany] = useState("");
  const [idealCompanies, setIdealCompanies] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const fetchIdealCompanies = async () => {
      setIsLoading(true);
      const response = await fetch(`${API_BASE_URL}/ideal-companies`);

      if (!response.ok) {
        return {
          error: response.message || "Failed to fetch companies.",
        };
      }

      const data = await response.json();
      setIdealCompanies(data.data);

      setIsLoading(false);
    };

    fetchIdealCompanies();
  }, []);

  const handleNewCompany = () => {
    const value = ref.current.value;
    if (!value) return;

    handleOtherCompanies(value);
    ref.current.value = "";
  };

  return (
    <>
      <div className="work-edit-wrapper-parent">
        <SearchSkillsAll
          handleSkillsChange={handleSkillsChange}
          details={details}
        />
        <div className="interested-in-working-for-wrapper">
          <div className="form-group">
            <label>Interested in working for</label>
            {isLoading ? (
              <Loader />
            ) : (
              <select
                value={selectedIdealCompany}
                onChange={(e) => {
                  const selectedId = parseInt(e.target.value);
                  const selectedCompany = idealCompanies.find(
                    (p) => p.id === selectedId
                  );

                  if (selectedCompany) {
                    handleIdealCompanies(selectedCompany);
                    setSelectValue("");
                  }
                }}
              >
                <option value="">Select Ideal Company</option>
                {idealCompanies.map((curr) => (
                  <option value={curr.id} key={curr.id}>
                    {curr.name}
                  </option>
                ))}
              </select>
            )}

            <div className="ideal-companies-picked bubble-wrapper-all">
              {details.ideal_companies.map((company, index) => (
                <div className="bubble-remove-all" key={index}>
                  <button
                    type="button"
                    onClick={(e) => handleIdealCompanies(company)}
                  >
                    <img src={closeIcon} alt="close-icon" />
                    <input
                      type="checkbox"
                      name="ideal_companies"
                      value={company.id}
                      checked
                      readOnly
                    />
                  </button>
                  {company.name}
                </div>
              ))}
            </div>

            <div className="add-other-company">
              <input
                ref={ref}
                type="text"
                placeholder="Add Other Company (optional)"
              />
              <button type="button" onClick={handleNewCompany}>
                <img src={addBtn} alt="addBtn" />
              </button>
            </div>

            <div className="other-companies-picked bubble-wrapper-all">
              {details.other_companies.map((company, index) => (
                <div className="bubble-remove-all" key={index}>
                  <button
                    type="button"
                    onClick={(e) => handleOtherCompanies(company)}
                  >
                    <img src={closeIcon} alt="close-icon" />
                    <input
                      type="checkbox"
                      name="other_companies"
                      value={company}
                      checked
                      readOnly
                    />
                  </button>
                  {company}
                </div>
              ))}
            </div>
          </div>
        </div>
        <JobPreferences
          handlePreferences={handlePreferences}
          details={details}
        />
        <SalaryField
          label="Minimum base salary"
          name="minimum_salary"
          placeholder="150,000"
          value={details.profile.minimum_salary}
          handleInput={handleInput}
        />
        <SalaryField
          label="Minimum bonus / comission"
          name="minimum_bonus"
          placeholder="150,000"
          value={details.profile.minimum_bonus}
          handleInput={handleInput}
        />
      </div>
    </>
  );
}
